import { IAssociatedListing } from '@app/models/AssociatedListing'
import {
  formatDate,
  formatListingPrice,
  humanize,
} from '@app/utils/formatting'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardBody, CardTitle } from 'reactstrap'

interface IAssociatedListingCardProps {
  listing: IAssociatedListing
}

export default class AssociatedListing extends React.PureComponent<
  IAssociatedListingCardProps
> {
  public render() {
    return (
      <Card>
        <CardBody>
          <CardTitle>
            For {humanize(this.props.listing.type)}, {this.props.listing.title}
          </CardTitle>
          <div>{formatListingPrice(this.props.listing)}</div>
          {this.props.listing.activeDate && (
            <div>
              Listed on{' '}
              {formatDate(this.props.listing.activeDate, 'MM/DD/YYYY')}
            </div>
          )}
          {this.props.listing.expirationDate && (
            <div>
              Expires on{' '}
              {formatDate(this.props.listing.expirationDate, 'MM/DD/YYYY')}
            </div>
          )}
          <div>Current status: {humanize(this.props.listing.status)}</div>
          <Link
            to={`/brokerage/listing/${this.props.listing.listingId}`}
            target='_blank'
          >
            View full listing
          </Link>
        </CardBody>
      </Card>
    )
  }
}
